export default {
  // A table named by a number alone, e.g. "Table 7"; other names stay as they are.
  label: 'Tisch {{name}}',
};
